/**
 * Server-parsed pipe table from CSV ingest (shown alongside structured import preview).
 */
import React from 'react';

const CsvParsedPreview = ({ summary, stats, warnings, partial }) => {
  if (!summary) return null;

  return (
    <div className="mt-3 surface-panel p-3 light-surface">
      <div className="flex flex-wrap items-center gap-2 mb-2">
        <p className="text-label text-secondary font-medium">Parsed from your CSV</p>
        {partial && (
          <span className="text-label px-2 py-0.5 rounded-md border border-warning text-warning bg-bone">
            Partial
          </span>
        )}
        {stats?.source_rows != null && (
          <span className="text-label text-faint figure">
            {stats.source_rows} row{stats.source_rows === 1 ? '' : 's'}
          </span>
        )}
      </div>
      {warnings?.length > 0 && (
        <ul className="text-label text-warning mb-2 list-disc list-inside space-y-0.5">
          {warnings.map((w, i) => (
            <li key={i}>{w}</li>
          ))}
        </ul>
      )}
      <pre className="text-label leading-relaxed text-secondary overflow-x-auto whitespace-pre font-mono max-h-48">
        {summary}
      </pre>
    </div>
  );
};

export default CsvParsedPreview;
